import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import AssignQuotePopupNewCustomerInput from "./assignQuotePopupNewCustomerInput";
import AssignQuotePopupNewCustomerSelect from "./assignQuotePopupNewCustomerSelect";
import {HOW_DID_YOU_HEAR_ABOUT_US_OPTIONS, PREFERRED_COMMUNICATION_METHODS} from "./assignQuoteConstants";
import AssignPopupContext from './assignPopupContext';
import AssignQuotePopupNewCustomerPhoneInput from "./assignQuotePopupNewCustomerPhoneInput";

const AssignQuotePopupNewCustomer = (props) => {

  const {isActive, fabricatorData} = props;
  const inputFields = {
    "firstName": "assignPopup.newCustomer.placeholders.firstName",
    "lastName":  "assignPopup.newCustomer.placeholders.lastName",
    "phoneNumber": "assignPopup.newCustomer.placeholders.phoneNumber1",
    "phone2":    "assignPopup.newCustomer.placeholders.phoneNumber2",
    "address1":  "assignPopup.newCustomer.placeholders.address1",
    "address2":  "assignPopup.newCustomer.placeholders.address2",
    "state":    "assignPopup.newCustomer.placeholders.state",
    "postal":    fabricatorData.isLowes ? "assignPopup.newCustomer.placeholders.postalLowes" : "assignPopup.newCustomer.placeholders.postal",
    "email":     "assignPopup.newCustomer.placeholders.email",
  };
  if (!fabricatorData.isCaesarStone) {
    delete inputFields["state"];
  }
  const selectFields = {
    "preferredCommunicationMethod": {
      placeholder: "assignPopup.newCustomer.placeholders.preferedCommunicationMethod",
      options: PREFERRED_COMMUNICATION_METHODS
    },
  };

  if (!fabricatorData.isCaesarStone) {
    selectFields["howDidYouHearAboutUs"] = {
      placeholder: "assignPopup.newCustomer.placeholders.howQuestion",
      options: HOW_DID_YOU_HEAR_ABOUT_US_OPTIONS
    }
  }

  return (
    <div className={"ass ass--new" + (isActive ? " ass--active" : "")}>
      <div className="ass-fields">
        {Object.keys(inputFields).map((property, propertyIndex) => {
          return (
            <AssignPopupContext.Consumer key={propertyIndex}>
              {/*{({context, setContext}) => (*/}
              {({inputsValidated}) => (property === "phoneNumber") ? (
                <AssignQuotePopupNewCustomerPhoneInput
                  inputsValidated={inputsValidated}
                  property={property}
                  placeholder={inputFields[property]}
                />
              ) : (
                <AssignQuotePopupNewCustomerInput
                  inputsValidated={inputsValidated}
                  property={property}
                  placeholder={inputFields[property]}
                />
              )}
            </AssignPopupContext.Consumer>
          )
        })}
        {Object.keys(selectFields).map((property, propertyIndex) => {
          return (
            <AssignQuotePopupNewCustomerSelect
              key={propertyIndex}
              property={property}
              select={selectFields[property]}
            />
          )
        })}
      </div>
    </div>
  )
};

AssignQuotePopupNewCustomer.propTypes = {
  isActive: PropTypes.bool.isRequired
};

const mapStateToProps = (store) => {
  return {
    assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText,
    fabricatorData: {}
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupNewCustomer)

